import React from 'react';

import ClaimStepContainer from '../common/ClaimStepContainer';

function MissingItemStepContainer(props) {
  return <ClaimStepContainer {...props} subHeading="MISSING_ITEM_CLAIM_FLOW_HEADING" confirmExit />;
}

export default React.memo(MissingItemStepContainer);
